export default __webpack_public_path__ + "static/media/Vendor_listview.988e4261.svg";